import { FC, useCallback, useState } from 'react';
import { formatDate, formatPrice } from '@utilities/functions';
import { CreditType } from '@utilities/types';
import { Button, Modal } from '@components';
import { OrderDetails } from './orderDetails';
import { CreditPaymentsHistory } from './CreditPaymentsHistory';
import { CheckCircle } from 'lucide-react';

interface ClosedCreditCardProps {
    credit: CreditType;
}

export const ClosedCreditCard: FC<ClosedCreditCardProps> = ({
    credit,
}) => {

    const { _clientID: client, amount, _saleID: sale, payments } = credit;

    const [displayDetailsOrder, setDisplayDetailsOrder] = useState<boolean>(false);
    const [displayHistory, setDisplayHistory] = useState<boolean>(false);

    const onToggleDetailsOrder = useCallback(() => {
        setDisplayDetailsOrder((prev) => !prev);
    }, []);

    const onToggleHistory = useCallback(() => {
        setDisplayHistory((prev) => !prev);
    }, []);

    return (
        <>
            <div className="bg-white shadow-md rounded-lg p-4 space-y-3 border border-green-200">
                <div className="flex justify-between items-center">
                    <h3 className="text-lg font-semibold text-primary">
                        {client.firstname} {client.lastname}
                    </h3>
                    <div className="flex items-center gap-1 text-green-600">
                        <CheckCircle className="w-4 h-4" />
                        <span className="text-sm font-medium">Soldé</span>
                    </div>
                </div>

                <div className="text-sm text-gray-700">
                    <p><strong>Montant total :</strong> {formatPrice(amount)}</p>
                    <p><strong>Téléphone :</strong> {client.phoneNumber}</p>
                    <p><strong>Commande :</strong> {sale.orderNumber}</p>
                    <p><strong>Date :</strong> {formatDate(sale.createAt)}</p>
                </div>

                {/* Barre de progression complète */}
                <div className="pt-2">
                    <div className="flex justify-between text-xs text-gray-500 mb-1">
                        <span>Remboursement complet</span>
                        <span className="text-green-600 font-medium">100%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                            className="bg-green-500 h-2 rounded-full"
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div className="flex flex-wrap gap-2 pt-2">
                    <Button variant="info" onClick={onToggleDetailsOrder}>
                        Voir les détails
                    </Button>

                    <Button variant="secondary" onClick={onToggleHistory}>
                        Historique ({payments.length})
                    </Button>
                </div>
            </div>

            <Modal
                isOpen={displayDetailsOrder}
                onClose={onToggleDetailsOrder}
                title={`Détails de la commande ${sale.orderNumber}`}
            >
                <OrderDetails
                    client={client}
                    sale={sale}
                    credit={credit}
                />
            </Modal>

            <Modal
                isOpen={displayHistory}
                onClose={onToggleHistory}
                title={"Historique des paiements du crédit"}
            >
                <CreditPaymentsHistory
                    credit={credit}
                />
            </Modal>
        </>
    );
};
